<template>
    <div class="login-wp">
        <com-header :type="1"></com-header>
        <div class="l-c"> 
            <div class="l-o">
                <p class="l-o-t">
                    登录
                </p>
                <div class="l-o-form">
                    <el-form ref="form" :model="form" style="width:80%;margin:0 auto;padding-top:50px;">
                        <!-- <el-form-item >
                            <div class="region-icon" direction="row">
							<i class="el-icon-set-up"></i>
							<el-select  v-model="form.region" placeholder="请选择角色" style="width: 300px">
						      <el-option label="设备厂家" value="shanghai"></el-option>
						      <el-option label="医疗机构" value="beijing"></el-option>
						    </el-select>
						    </div>
                        </el-form-item> -->
                        <el-form-item >
                            <el-input v-model="form.userName"  prefix-icon="el-icon-user" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item >
                            <el-input v-model="form.password" type="password"  prefix-icon="el-icon-unlock" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item style="margin-bottom:30px;">
                            <div class="code-box">
                                <el-input v-model="form.yzm" style="width:150px;" prefix-icon="el-icon-circle-check" placeholder="请输入验证码"></el-input>
                                <canvas class="code-img"  ref="code" @click="setDrawCode">对不起，您的浏览器不支持canvas，请下载最新版浏览器!</canvas>
                            </div>
                        </el-form-item>
                        <el-form-item style="margin-bottom:20px;">
                               <el-checkbox v-model="checked" @change="rememberPwd">记住密码</el-checkbox>
                               <p class="pointer" style="width:100px;height:30px;float:right;margin:0;color:#7E7E7E;" @click="routerToUrl('/resetPassword')">忘记密码</p>
                        </el-form-item>
                        <el-form-item style="margin-bottom:10px;">
                            <el-button type="primary" style="width:100%;background:#2178E1;height:50px;" @click="userLogin">登录</el-button>
                        </el-form-item>
                        <el-form-item style="margin-top:20px;">
                               <p class="pointer" style="width:100px;height:30px;float:right;margin:0;color:#2077E0;" @click="routerToUrl('/register')">用户注册</p>
                               <!-- <p style="width:100px;height:30px;float:right;margin:0;color:#2077E0;">验证码登录<img style="position:relative;top:7px;left:5px;" src="../../../assets/image/login/letgo.png"></p> -->
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <com-footer></com-footer>
    </div>

</template>
<script>
import Login from './Login.js';
export default Login;
</script>
<style lang="scss" scoped>
@import './Login.scss';
</style>
<style lang="scss">
.l-o-form{
    /*icon角色*/
    .el-input--suffix .el-input__inner{
        padding-left: 30px!important;
    }
}
</style>